import tokeys from 'tokeys';

export const AzureVariable = tokeys(['string', 'number', 'boolean']);

export const envVariablesSchema = {
  environment: AzureVariable.string,
  apiHost: AzureVariable.string,
  enablePersistanceOnLocalStorage: AzureVariable.boolean,
  disablePersistanceCompression: AzureVariable.boolean,
  disableReCaptcha: AzureVariable.boolean,
  googleAnalyticsKey: AzureVariable.string,
  onetrustKey: AzureVariable.string,
  enableLoadingType: AzureVariable.boolean,
  enableVirikeLoadingType: AzureVariable.boolean,
  enableDepositsUpdate: AzureVariable.boolean,
  depositUpdateAllowedIds: AzureVariable.string,
  enableNewBenefitGroups: AzureVariable.boolean
};
